var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"auth-layout"},[_c('AuthNav',{attrs:{"route":_vm.$route,"token":_vm.token,"platform_name":_vm.platform_name}}),_c('div',{staticClass:"container"},[_c('SlideYUpTransition',{attrs:{"mode":"out-in","origin":"center top"}},[_c('router-view')],1)],1),_c('div',{staticClass:"bg_sm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }